export const OPEN_COMPOSER_MESSAGE =
  "discourse-mod-market:open-comment-composer";
export const COMPOSER_OPENED_MESSAGE =
  "discourse-mod-market:comment-composer-opened";
export const COMPOSER_CLOSED_MESSAGE =
  "discourse-mod-market:comment-composer-closed";
export const COMPOSER_OPEN_CLASS = "is-mod-market-composer-open";

export function isTrustedComposerMessage(
  event,
  { type, origin = window.location.origin, source }
) {
  return (
    event.origin === origin &&
    event.source === source &&
    event.data?.type === type
  );
}

export function postComposerMessage(target, type, origin = window.location.origin) {
  target?.postMessage({ type }, origin);
}
